module.exports = __webpack_public_path__ + "img/1970East-046_WEB-min.9dfc8661.jpg";